import PersonDocumentService from '../services/person-document-service';

export const personDocument = {
  namespaced: true,
  state: {
    document: null,
  },
  actions: {
    newDocument({ commit }, trustmarkPersonId) {
      const template = {
        internalNotes: '',
        trustmarkPersonDocumentType: '',
        filename: '',
        link: '',
        documentDate: new Date(),
      };
      const empty = JSON.parse(JSON.stringify(template));
      empty.trustmarkPersonId = trustmarkPersonId;
      commit('setDocument', empty);
    },
    addDocument({ commit }, data) {
      commit('setIsBusy', true, { root: true });
      return PersonDocumentService.create(data)
        .then((result) => {
          commit('setDocument', false, { root: true });
          const { message } = result;
          return Promise.resolve(message);
        })
        .catch((error) => {
          commit('setIsBusy', false, { root: true });
          return Promise.reject(error);
        });
    },
    loadDocument({ commit }, document) {
      commit('setDocument', document);
    },
  },
  mutations: {
    setDocument(state, newDocument) {
      state.document = newDocument;
      if (state.document) {
        state.document.documentDate = new Date(state.document.documentDate);
      }
    },
  },
};
